import type { ComponentPropsWithoutRef } from 'react';
import { SvgIcon, Icon as MuiIcon } from '@mui/material';

import { tss } from 'tss-react/mui';

import Hub from 'Images/menu/myHubIcon.svg';
import News from 'Images/menu/newsIcon.svg';
import Groups from 'Images/menu/myGroupsIcon.svg';
import Group from 'Images/menu/groupIcon.svg';
import School from 'Images/menu/schoolIcon.svg';

const useStyles = tss
  .withParams<{ iconSize: number }>()
  .create(({ theme, iconSize }) => {
    return {
      icon: {
        fontSize: `${iconSize}px`,
      },
      muiIcon: {
        color: theme.palette.action.active,
      },
    };
  });

interface Props extends ComponentPropsWithoutRef<typeof SvgIcon> {
  children: string;
  size?: number;
}

export const Icon = ({ children: iconName, size = 32, ...other }: Props) => {
  const { classes, cx } = useStyles({ iconSize: size });
  const props = {
    viewBox: '0 0 65.2 65.2',
    ...other,
  };

  let component: React.ComponentType | null = null;
  switch (iconName.toLowerCase()) {
    case 'home':
      component = Hub;
      break;
    case 'chrome_reader_mode':
      component = News;
      break;
    case 'list':
      component = Groups;
      break;
    case 'group':
      component = Group;
      break;
    case 'school':
      component = School;
      break;
    default:
      break;
  }

  return component ? (
    <SvgIcon
      classes={{ root: classes.icon }}
      component={component}
      {...props}
    />
  ) : (
    <MuiIcon
      classes={{ root: cx(classes.muiIcon, 'material-icons-outlined') }}
      fontSize="inherit"
    >
      {iconName}
    </MuiIcon>
  );
};
